<app-link [to]="to">
  <div class="card-product -title">
    <icon *ngIf="icon" [icon]="icon" [class]="iconsize + ' ' + iconcolor"></icon>
    <h3>{{title}}</h3>
  </div>
  <ng-content></ng-content>
</app-link>